import { render, staticRenderFns } from "./DiaryEditor.vue?vue&type=template&id=dcd80600"
import script from "./DiaryEditor.vue?vue&type=script&lang=js"
export * from "./DiaryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports